import * as React from 'react'

import { BorderRadiusCorners, Box, Text, Touchable } from '@factorialco/deprecated-design-system'

import UnsafeRadioInput from 'modules/shift_management/components/ShiftManagement/UnsafeRadioInput'

interface WrapperProps {
  children?: React.ReactNode
  description: string
  isSelected: boolean
  onSelected: () => void
  newVersion?: boolean
}

const Wrapper = ({
  children,
  description,
  isSelected,
  onSelected,
  newVersion = false,
}: WrapperProps) => {
  const borderRadius: BorderRadiusCorners = {
    all: newVersion ? 'abs016' : 'abs008',
  }

  return (
    <Box background="grey200" borderRadius={borderRadius}>
      <Box
        border={{
          all: {
            width: 's2',
            style: 'solid',
            color: isSelected ? 'viridian1000' : 'grey400',
          },
        }}
        borderRadius={borderRadius}
        background="grey000White"
      >
        <Box
          alignItems="center"
          borderRadius={borderRadius}
          padding="s16"
          flexDirection="row"
          justifyContent="spaceBetween"
          background="grey000White"
        >
          <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s4">
            <Text size="300" weight="semibold" color="grey800">
              {description}
            </Text>
          </Box>

          <Touchable onClick={onSelected}>
            <UnsafeRadioInput selected={isSelected} />
          </Touchable>
        </Box>
        {children}
      </Box>
    </Box>
  )
}

export default Wrapper
